import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './auth/AuthContext';
import { TimezoneProvider } from './contexts/TimezoneContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TimezoneProvider>
          <App />
        </TimezoneProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
